export default __webpack_public_path__ + "media/images/person-43e91ab50a7489d234822a0921d88e5a.jpg";